import { Box } from '@mui/material';

import { EventHandlerAndPayloadModel } from '../../../api/api';
import { CodeBaseModel, CodeStoreFileModel } from '../../../api/api';
import EventHandlerItem from './EventHandlerItem';

interface Props {
	handlers: EventHandlerAndPayloadModel[];
	applicationCodeFiles?: CodeStoreFileModel[];
	applicationCodeBase?: CodeBaseModel | null;
	onRefreshCodeFile?: (fileName: string) => void | Promise<void>;
	onSelectHandler?: (handlerId: string) => void;
	onUpdateHandler?: (handlerId: string, name: string, description: string, tags: string[]) => Promise<unknown>;
	onDeleteHandler?: (handlerId: string) => Promise<unknown>;
	selectedHandlerId?: string;
}

const EventHandlerList: React.FC<Props> = ({
	handlers,
	applicationCodeFiles,
	onRefreshCodeFile,
	onSelectHandler,
	onUpdateHandler,
	onDeleteHandler,
	selectedHandlerId,
}) => {
	const codeFiles = applicationCodeFiles ?? [];

	const getHandlerCodeFile = (eventName: string): CodeStoreFileModel | null => {
		var target = eventName.replace(/-/g, '') + 'EventHandler.cs';
		if (target.toLowerCase().startsWith('on')) {
			target = target.substring(2);
		}

		const lowerTarget = target.toLowerCase();
		return codeFiles.find((file) => file.name.toLowerCase() === lowerTarget) ?? null;
	};

	return (
		<>
			<Box sx={{ pl: 2, pr: 2, mb: 5, maxWidth: '100%' }}></Box>
			<Box sx={{ pl: 2, pr: 2, maxWidth: '100%' }}>
				{handlers.map((handler) => (
					<EventHandlerItem
						key={handler.handler.id}
						eventHandler={handler}
						eventHandlerCode={getHandlerCodeFile(handler.handler?.name)}
						onRefreshCodeFile={onRefreshCodeFile}
						onSelect={onSelectHandler ? () => onSelectHandler(handler.handler.id) : undefined}
						onUpdate={onUpdateHandler}
						onDelete={onDeleteHandler}
						expanded={selectedHandlerId ? selectedHandlerId === handler.handler.id : undefined}
					/>
				))}
			</Box>
		</>
	);
};

export default EventHandlerList;
